import { render, staticRenderFns } from "./documentos-componente.vue?vue&type=template&id=57b6c157"
import script from "./documentos-componente.vue?vue&type=script&lang=js"
export * from "./documentos-componente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports